import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '首页', to: '/' },
      { label: '电影频道', to: '/category/movie' },
      { label: '电视剧频道', to: '/category/tv' },
      { label: '综艺频道', to: '/category/variety' },
    ],
  },
  {
    title: '关于网站',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '搜索影视', to: '/search' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2 max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="text-xl font-extrabold text-background-50 tracking-tight">看片</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/75">
              看片影视大全为您精选最新电影、热门电视剧与精彩综艺节目，提供清晰的内容导航与便捷的浏览体验。本站内容均为信息展示，旨在帮助您发现好片、快速找到想看的内容。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-100/75 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-100/60">
            © {new Date().getFullYear()} 看片影视大全 · 本站所有影视内容仅供信息展示与浏览
          </p>
          <p className="text-xs text-primary-100/60">
            声明：站内资源均为演示内容，不提供播放、会员或下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}